(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Lycabinet", [], factory);
	else if(typeof exports === 'object')
		exports["Lycabinet"] = factory();
	else
		root["Lycabinet"] = factory();
})(self, function() {
return 